//core
import React, { useContext, useState, useEffect, useCallback } from "react";
import arePropsEqual from "react-fast-compare";
import { Box, Checkbox } from "@mui/material";

//styles
import { useStyles } from "./styles";

//context
import { WebhooksReportContext } from "../../../../admin/Reports/WebhooksReport/WebhooksReportContext";

//hooks
import { usePermissions } from "../../../../../store/common/configuration/usePermissions";

//utils
import { canWebhookResend } from "../../../../admin/Reports/WebhooksReport/utils";

//types
import { itemListData } from "../../index";

interface IText {
  value: string | number;
  data: itemListData;
  setSelectedRow: (state: boolean) => void;
}

const SelectedWebhooksReportRow = ({
  value = '',
  data,
  setSelectedRow,
}: IText) => {
  const styles = useStyles();
  const context = useContext(WebhooksReportContext);
  const { hasPermissions } = usePermissions();

  const hasResendPermission = hasPermissions(["api2.admin.webhookstaskscontroller.resend"]);

  const [checked, setChecked] = useState(false);

  const canResend = canWebhookResend(data.created_at, data.status);

  useEffect(() => {
    setChecked(context.selectedWebhooks.some((item: any) => `${item.id}` === `${data.id}`));
  }, [context.selectedWebhooks, data.id]);

  useEffect(() => {
    if (checked) {
      setSelectedRow(true);
    } else {
      setSelectedRow(false);
    }
  }, [checked]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const selected: itemListData = data;

    if (event.target.checked) {
      context.addSelectedWebhooks(selected);
    } else {
      const filtered = context.selectedWebhooks.filter(item => {
        return item.id !== selected.id
      });
      context.setSelectedWebhooks(filtered)
    }

    setChecked(event.target.checked);
  }, [data, setChecked, context.selectedWebhooks]);

  return (
    <Box
      component="span"
      className={styles.block}
    >
      {hasResendPermission && (
        <Checkbox
          size="small"
          sx={{ padding: '4px' }}
          checked={checked}
          disabled={!canResend}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      )}
      <span className={styles.text}>{value}</span>
    </Box>
  );
};

export default React.memo(SelectedWebhooksReportRow, arePropsEqual);
